import { useEffect, useRef, useState } from "react";
import { DOOR } from "../../portalContent";
import { usePrefersReducedMotion } from "../../hooks/usePortal";

const DUST = Array.from({ length: 16 }, (_, i) => i);
const OPEN_MS = 1700;

export default function DoorEntrance({ wordmark, name, descriptor, onOpened }) {
  const stage = useRef(null);
  const [phase, setPhase] = useState("idle");
  const reduced = usePrefersReducedMotion();

  useEffect(() => {
    if (phase !== "opening") return undefined;
    const timer = window.setTimeout(onOpened, reduced ? 0 : OPEN_MS);
    return () => window.clearTimeout(timer);
  }, [phase, reduced, onOpened]);

  // Pointer parallax writes CSS variables directly, so it never triggers a React render.
  const handleMove = (event) => {
    if (reduced || !stage.current) return;
    const rect = stage.current.getBoundingClientRect();
    const x = (event.clientX - rect.left) / rect.width - 0.5;
    const y = (event.clientY - rect.top) / rect.height - 0.5;
    stage.current.style.setProperty("--px", x.toFixed(3));
    stage.current.style.setProperty("--py", y.toFixed(3));
  };

  return (
    <section ref={stage} className={`pt-door-stage is-${phase}`} onPointerMove={handleMove} aria-label={`${name} entrance`}>
      <div className="pt-door-aura" aria-hidden="true" />
      <div className="pt-dust" aria-hidden="true">
        {DUST.map((i) => <span key={i} style={{ "--i": i }} />)}
      </div>

      <header className="pt-door-brand">
        {wordmark ? <img src={wordmark} alt={name} /> : <h1>{name}</h1>}
        {descriptor && <p>{descriptor}</p>}
      </header>

      <button type="button" className="pt-door" onClick={() => setPhase("opening")} disabled={phase !== "idle"} aria-label={`${DOOR.hint}: ${name}`}>
        <span className="pt-door-frame">
          <span className="pt-door-light" />
          <span className="pt-door-leaf">
            <span className="pt-door-panel pt-door-panel-top" />
            <span className="pt-door-panel pt-door-panel-bottom" />
            <span className="pt-door-handle" />
          </span>
        </span>
        <span className="pt-door-spill" aria-hidden="true" />
      </button>

      <div className="pt-door-copy">
        <p className="pt-door-line">{DOOR.line}</p>
        <p className="pt-door-hint"><span aria-hidden="true" className="pt-door-pulse" />{DOOR.hint}</p>
      </div>

      <div className="pt-flash" aria-hidden="true" />
    </section>
  );
}
